import React from 'react';
import NavBar from '../../components/Navbar/NavBar';
import FooterOne from '../../components/Footer/Footer';
import { Grid, Typography, Box } from '@mui/material';
import DonationCard from '../../components/DonationCard';
import donationOptions from '../../components/DonationOptions';


const DonationsAndGifts = () => {
    // Function to handle Add to Cart button click
    const handleAddToCart = () => {
        window.open("https://www.paypal.com/webapps/shoppingcart?mfid=1707406483716_f846759f0b2bb&flowlogging_id=f846759f0b2bb#/checkout/shoppingCart", "_blank");
    };

    return (
        <Box>
            <NavBar />
            <Typography variant="h3" gutterBottom align="center" sx={{ m: 3, mt: 12, fontWeight: 'bold' }}>
                Alternative Gifts
            </Typography>
            <Typography variant="body1" align="center" sx={{ m: 2 }}>
                If you don't want to sponsor a girl but you still wish to support BEADS programs in Kenya, here are a few options you might consider!
            </Typography>
            <Grid container spacing={2} sx={{ p: 2 }}>
                {donationOptions.map((option, index) => (
                    <Grid item xs={12} sm={6} md={4} key={index} sx={{ mb: 4 }}>
                        <DonationCard {...option} handleAddToCart={handleAddToCart} readMoreLink={option.readMoreLink} />
                    </Grid>
                ))}
            </Grid>
            <FooterOne />
        </Box>
    );
}

export default DonationsAndGifts;
